module.exports = __webpack_public_path__ + "img/icn-crisis.ea80e37b.svg";